import { Select, TextInput } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { EventFormValues } from "./types";

interface EventFormCategoryProps {
  form: UseFormReturnType<EventFormValues>;
  t: (key: string) => string;
  language: string;
  tags: { id: number; tag: string; tag_pt?: string }[];
  setUserSelectedTag: (value: boolean) => void;
}

export const EventFormCategory = ({
  form,
  t,
  language,
  tags,
  setUserSelectedTag,
}: EventFormCategoryProps) => {
  return (
    <>
      <Select
        mt="md"
        label={t("events.category")}
        data={tags
          .sort((a, b) => {
            // Sort based on the language-specific tag
            const aValue = language === "pt-PT" ? a.tag_pt || a.tag : a.tag;
            const bValue = language === "pt-PT" ? b.tag_pt || b.tag : b.tag;
            return aValue > bValue ? 1 : -1;
          })
          .map((t) => {
            // Return the appropriate tag based on language
            return language === "pt-PT" ? t.tag_pt || t.tag : t.tag;
          })}
        {...form.getInputProps("mainTag")}
        onChange={(value) => {
          form.setFieldValue("mainTag", value);
          setUserSelectedTag(true);
        }}
        searchable
        clearable
        error={form.errors.mainTag}
        withAsterisk={form.values.published}
      />
      <TextInput
        mt="md"
        label={t("events.registration_link")}
        {...form.getInputProps("registrationLink")}
      />
    </>
  );
};
